import React from "react";
import ReactDOM from "react-dom/client";
import Pages from "./Pages";
import { Provider } from "react-redux";
import store from "./Redux";
import { Toaster } from "react-hot-toast";
import "react-tooltip/dist/react-tooltip.css";
import "./Assets/Css/animations.css";
import "./Assets/Css/styles.css";
import { toast } from "./Utils/constants";
import { SidePaneProvider, TopBarProvider, InternetMonitor } from "./Components";
import LockScreen from "./Components/LockScreen";
import { BrowserRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import { gtmScript } from "./Utils/gtm";
import { startVersionCheck } from "./versionCheck";

startVersionCheck({ intervalMs: 30_000 });

console.info(" v24022026_04.25 Latest Build: 24-02-2026");
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
	<>
		<Helmet>
			{/* Google Tag Manager */}
			<script>{gtmScript()}</script>
		</Helmet>
		<Toaster toastOptions={toast} />
		<InternetMonitor />
		<Provider store={store()}>
			{/* <SplashScreen /> */}
			<LockScreen />
			{/* Context to change SidePane's content dynamically */}
			<SidePaneProvider>
				{/* Context to change TopBar's content dynamically */}
				<TopBarProvider>
					<BrowserRouter>
						<Pages />
					</BrowserRouter>
				</TopBarProvider>
			</SidePaneProvider>
		</Provider>
	</>
);
